// extracted by mini-css-extract-plugin
export default {"legendIndicator":"ana-z","legendNew":"bna-z"};